var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-this-banner"},[_c('asset-meta',{attrs:{"resource":_vm.currentResource}}),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":"window-restore"}}),_c('span',[_vm._v("Open in new window")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }